import React, { useEffect, useState } from "react";
import { useTransition } from "@react-spring/web";
import "./style.scss";
import { fetchData, useSessionStorage } from "../../Helpers";
import NiceModal from "@ebay/nice-modal-react";

export const finishFindGame = (queryClient) => {
  fetchData({
    endpoint: "/activation/solution/create",
    payload: {
      activation: {
        ident: "quiz_7",
        payload: [
          {
            question_ident: "q0",
            answer_ident: "30a79be3-7523-40b1-bdb3-1b8491616b66",
          },
          {
            question_ident: "q1",
            answer_ident: "0ee97f02-ba45-461f-af80-1e4908f05cb3",
          },
          {
            question_ident: "q2",
            answer_ident: "b8edea17-1d1c-4298-9856-3ce5f9da645b",
          },
          {
            question_ident: "q3",
            answer_ident: "5ccb5054-1517-466f-84b2-6da31eed5532",
          },
          {
            question_ident: "q4",
            answer_ident: "f67b6c22-dd45-427f-b9a4-a8a59be6436b",
          },
        ],
      },
    },
    successCallback: (resObj) => {
      queryClient.refetchQueries({
        queryKey: ["message-list"],
      });
      queryClient.refetchQueries({
        queryKey: ["user-details"],
      });
      queryClient.refetchQueries({
        queryKey: ["activation-list"],
      });
      window.sessionStorage.removeItem("showGame");
      window.sessionStorage.setItem("foundObject", []);
      window.dispatchEvent(new Event("storage"));
      NiceModal.show("last-found-object-modal");
    },
  });
};

export const getObjectArray = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem("foundObject")) ?? [];
  } catch (e) {
    return [];
  }
};

export default function Object({ uuid, bottom, image, copy, innerImage }) {
  const [popupOpen, setPopupOpen] = useState(false);
  const [foundObject, setFoundObject] = useSessionStorage("foundObject", []);
  const [findObjectGameFinished, setFindObjectGameFinished] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [box, setBox] = useState(null);

  useEffect(() => {
    const updateGameStatus = () => {
      setShowGame(window.sessionStorage.getItem("showGame") ? true : false);
    };

    updateGameStatus();
    window.addEventListener("storage", updateGameStatus);

    const originalSetItem = window.sessionStorage.setItem;
    window.sessionStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      updateGameStatus();
    };

    const currentDate = new Date();
    const targetDate = new Date("2024-11-06");

    if (currentDate >= targetDate) {
      setFindObjectGameFinished(true);
    } else {
      setFindObjectGameFinished(false);
    }
  }, []);

  const transitionEgg = useTransition(
    !foundObject.includes(uuid) || popupOpen,
    {
      enter: {
        opacity: 1,
      },
      leave: {
        opacity: 0,
      },
    }
  );

  const onObjectClick = (e) => {
    if (clicked) {
      return;
    }
    e.preventDefault();
    setPopupOpen(true);
    setClicked(true);
    window.dispatchEvent(new Event("storage"));
    if (foundObject.length === 0) {
      setFoundObject([uuid]);
    } else {
      setFoundObject((prev) => [...prev, uuid]);
    }
  };

  if (findObjectGameFinished) {
    return <></>;
  }

  if (!showGame) {
    return <></>;
  }

  return (
    <div
      className={`hidden-object ${bottom ? bottom : ""}`}
      onClick={() => {
        console.log("click");
        NiceModal.show("found-object-modal", {
          cancel: false,
          componentSetOpen: () => setPopupOpen(false),
          innerImage,
          copy,
        });
      }}
    >
      {transitionEgg((style, item) =>
        item ? (
          <img
            src={image}
            alt="find-game-object"
            onClick={(e) => onObjectClick(e)}
            ref={setBox}
          />
        ) : (
          ""
        )
      )}
    </div>
  );
}
